import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-daf0a62a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "share-icon" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "banner-tc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-tc-divider" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "rights-title" }
const _hoisted_10 = { class: "rights-title-extra" }
const _hoisted_11 = { class: "rights-wrapper" }
const _hoisted_12 = { class: "rights-list" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "remark" }
const _hoisted_16 = {
  key: 2,
  class: "submit"
}

import { computed, onBeforeMount, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { CommonTitle, MyButton, Tab, SortList } from './components';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { CallErrorType, isCommonError, openSharePanel, ShareChannel, shareLink } from '@tencent/vb-app-bridge';
import { ShareResponse } from '@tencent/vb-app-bridge/lib/src/type/share';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { isFusionBankApp, to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';
import { CheckTeslaWhiteAndOwnerInfo, GetRightHomeConfig } from '../../core/network/NodeAPI';
import { IOptionItemData, IOtherRightHomeConfig } from '../../core/interface/IModel';
import { CheckNoTeslaWhiteAndIsElectricCar, GetRightList } from '@common/core/network/activityAPI';
import { IRightSortConfig, IRightItem } from '@common/core/interface/IModel';
import { ProductInfoMap } from '@common/core/help/constant';
import { useGlobalState } from '../../store/carOwnerRight';
import dayjs from 'dayjs';
import { getUrlQuery } from '@common/utils/param';
import Contract from '@tencent/vb-web-contract';


export default /*#__PURE__*/_defineComponent({
  __name: 'OtherOverview',
  setup(__props) {

const route = useRoute();
const { isAuth, isActive = '0' } = route.query;
const isAuthLabel = ref('');
isAuthLabel.value = isAuth as string;
const state = useGlobalState();
const { setTitle, showModalError, isEng } = baseMixins();
// 多语言设置标题
const { getT } = i18n;
// i18n.setLang('en-GB');
const $t = getT();
const isOutdate = computed(() => {
  if (state.value.date[0] && dayjs().isBefore(dayjs(state.value.date[0]))) {
    return true;
  }
  if (state.value.date[1] && dayjs().isAfter(dayjs(state.value.date[1]))) {
    return true;
  }
  return false;
});
setTitle($t('富融车主会'));
// 活动首页配置
const configInfo = reactive<IOtherRightHomeConfig>({
  bannerImg: '',
  rightTitle: [],
  infoImg1: '',
  infoImg2: '',
  infolink1: '',
  infolink2: '',
  activityImg1: '',
  activityLink1: '',
  activityImg2: '',
  activityLink2: '',
  remark: [],
});
const getConfigInfo = async () => {
  const [data, err] = await to(GetRightHomeConfig<IOtherRightHomeConfig>({ brand: 'other', channel: 'app' }));
  if (err) {
    showModalError(err.message, err.code);
    return;
  }
  configInfo.bannerImg = data.bannerImg;
  configInfo.infoImg1 = data.infoImg1;
  configInfo.infoImg2 = data.infoImg2;
  configInfo.infolink1 = data.infolink1;
  configInfo.infolink2 = data.infolink2;
  configInfo.rightTitle = data.rightTitle;
  configInfo.remark = data.remark;
  configInfo.activityImg1 = data.activityImg1;
  configInfo.activityLink1 = data.activityLink1;
  configInfo.activityImg2 = data.activityImg2;
  configInfo.activityLink2 = data.activityLink2;
};

// 前往活动页
const goActivityPage = (link: string) => {
  if (link) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    window.top!.location.href = link;
  }
};

// 活动权益列表
let rightList: IRightItem[] = [];
const tabData = ref<IOptionItemData[]>([]);
const activeTabValue = ref('3');
const curSorts = ref<IRightSortConfig[]>([]);
const getRightList = async () => {
  if (state.value.allOtherRightList?.length) {
    rightList = state.value.allOtherRightList;
  } else {
    const [data, err] = await to(GetRightList('other'));
    if (err) {
      showModalError(err.message, err.code);
      return;
    }
    state.value.allOtherRightList = data;
    rightList = data;
  }
  setCurRights();
  tabData.value = rightList.map((item) => {
    const obj: IOptionItemData = {};
    obj.value = item.rankIndex;
    obj.label = item.rank.replace(' ', '\n\r');
    return obj;
  });
};

const setCurRights = () => {
  const rightItem = rightList.find((item) => item.rankIndex === activeTabValue.value);
  if (rightItem) {
    curSorts.value = rightItem.sorts;
  }
};
// 检查用户是否tesla车主
const isTeslaOwner = ref(false);
const checkTeslaOwner = async () => {
  const [data] = await to(CheckTeslaWhiteAndOwnerInfo());
  // if (err) {
  //   showModalError(err.message, err.code);
  // }
  if (data?.isInTeslaWhite) {
    isTeslaOwner.value = true;
  }
};

// 检查用户是否非tesla车主白名单
const checkNoTeslaWhite = async () => {
  const [data] = await to(CheckNoTeslaWhiteAndIsElectricCar());
  // if (err) {
  //   showModalError(err.message, err.code);
  // }
  if (data?.isInNoTeslaWhite) {
    isAuthLabel.value = '0';
  }
};

// 分享活动
const handleShare = async () => {
  reportStatistics({
    evtName: 'linkShare',
    desc: '全量车主权益活动分享按钮点击',
  });
  try {
    const channel = await openSharePanel([
      ShareChannel.FACEBOOK,
      ShareChannel.WECHAT_MESSAGE,
      ShareChannel.WECHAT_MOMENT,
      ShareChannel.MESSENGER,
      ShareChannel.MORE,
    ]);
    if (channel === ShareChannel.UNKNOWN) {
      // 需要处理未知的渠道
      return;
    }
    /* eslint-disable */
    const result = await shareLink(channel, {
      thumbPath: require('@/assets/images/carOwnerRight/share-notesla.png'),
      title: `🚗${$t('富融车主会 ·「赏」你所想')}`,
      link: `${window.origin}/h5/walletLoan/activity/index.html?activeTag=carOwnerRight#/otherRegister`,
      content: `📢${$t('邀请你加入富融车主会，入会可享价值高达港币8,600元会员礼遇')}💰`,
    });
    if (result.result === '0') {
      reportStatistics({
        evtName: 'linkShareSuccess',
        desc: '全量车主权益活动分享成功',
      });
    }
  } catch (err) {
    if (isCommonError(err)) {
      if (err.type === CallErrorType.OTHER_ERROR) {
        const { msg, result } = err.result as ShareResponse;
        if (result !== '0') {
          reportStatistics({
            evtName: 'linkShareError',
            desc: '全量车主权益活动分享失败',
          });
        }
        console.log(msg);
        // 0    分享成功
        // -1    分享失败
        // -2    分享渠道对应app没安装
        // -3    用户主动取消
        // -4    相册权限未经用户授权    涉及图片操作时需要该权限
      }
    }
  }
};

const submitBtnState = computed(() => {
  if (isTeslaOwner.value) {
    return {
      text: $t('您已享Tesla车主专享礼遇'),
      extraText: $t('无需再次登记'),
      status: 'disabled',
    };
  }
  if (isAuthLabel.value === '0') {
    return {
      text: $t('立即提款'),
      status: 'auth',
    };
  }
  return {
    text: $t('立即入会'),
    status: 'noAuth',
  };
});

const handleClick = async (status: string) => {
  const senceId = getUrlQuery('senceId') || '';

  if (status === 'auth') {
    await reportStatistics({
      evtName: 'drawBtnClick',
      desc: '全量车主权益预览页面立即提款按钮点击',
    });
    // 有时跳转页面很慢，需要给个loading动画
    spin.show();
    setTimeout(() => {
      spin.hide();
    }, 3000);

    window.top!.location.href = `/h5/walletLoan/app/index.html?senceId=${senceId}&product_no=${ProductInfoMap.DEFAULT}&activeTag=${ProductInfoMap.DEFAULT}&from=otherRight`;
  } else {
    const res = await accountCheck({
      needAutoLogin: true,
      loginReload: true,
      needActivateModal: true,
      needOpenModal: true,
    });
    if (res.code === RESULTCODE.LOGINRELOAD) {
      return;
    }
    if (res.code !== RESULTCODE.SUCCESS) {
      return;
    }
    await reportStatistics({
      evtName: 'joinBtnClick',
      desc: '全量车主权益预览页面立即入会按钮点击',
    });
    // 有时跳转页面很慢，需要给个loading动画
    spin.show();
    setTimeout(() => {
      spin.hide();
    }, 3000);

    window.top!.location.href = `/h5/walletLoan/app/index.html?senceId=${senceId}&product_no=FyvFkIqLYfHM3ju&from=allRegister#/carRegister`;
  }
};

watch(activeTabValue, () => {
  reportStatistics({
    evtName: `rightRank${activeTabValue.value}BtnClick`,
    desc: `存量车主权益预览页面奖品等级${activeTabValue.value}按钮点击`,
  });
  setCurRights();
});

// 预览合同
async function previewContract(key: string) {
  const contractObj = new Contract({
    key,
    autoSign: false,
    containerType: 'dialog',
    needAgree: false,
    needLogin: false,
    needBackBtn: !isFusionBankApp,
    needTitle: !isFusionBankApp,
    needCheckBox: false,
    hideBtn: true,
  });

  await contractObj.preview();
}

onBeforeMount(async () => {
  spin.show();
  await Promise.all([getConfigInfo(), getRightList()]);
  spin.hide();
  if (!isAuthLabel.value) {
    checkNoTeslaWhite();
  }
  checkTeslaOwner();
});

return (_ctx: any,_cache: any) => {
  const _directive_stat = _resolveDirective("stat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "share",
        onClick: handleShare
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref($t)('分享')), 1)
      ]),
      _createElementVNode("img", {
        src: configInfo.bannerImg,
        alt: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (previewContract('CreditLineKFS'))),
          class: "banner-tc-text"
        }, [
          _createTextVNode(_toDisplayString(_unref($t)('产品资料概要')), 1)
        ])), [
          [_directive_stat, { event: 'teslaCreditLineKFS', num: '1' }]
        ]),
        _hoisted_6,
        _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (previewContract('CreditLineTC'))),
          class: "banner-tc-text"
        }, [
          _createTextVNode(_toDisplayString(_unref($t)('条款及细则')), 1)
        ])), [
          [_directive_stat, { event: 'teslaCreditLineTC', num: '1' }]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "info",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (goActivityPage(configInfo.infolink1)))
    }, [
      _createElementVNode("img", {
        src: configInfo.infoImg1,
        alt: ""
      }, null, 8, _hoisted_7)
    ]),
    (configInfo.activityImg1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "activity",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (goActivityPage(configInfo.activityLink1)))
        }, [
          _createElementVNode("img", {
            src: configInfo.activityImg1,
            alt: ""
          }, null, 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["rights", { eng: _unref(isEng) }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(CommonTitle), {
          title: configInfo.rightTitle[0]
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, _toDisplayString(configInfo.rightTitle[1]), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(Tab), {
          options: tabData.value,
          modelValue: activeTabValue.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTabValue).value = $event)),
          theme: "gray"
        }, null, 8, ["options", "modelValue"]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(SortList), { sorts: curSorts.value }, null, 8, ["sorts"])
        ])
      ])
    ], 2),
    (configInfo.activityImg2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "activity",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (goActivityPage(configInfo.activityLink2)))
        }, [
          _createElementVNode("img", {
            src: configInfo.activityImg2,
            alt: ""
          }, null, 8, _hoisted_13)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "info",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (goActivityPage(configInfo.infolink2)))
    }, [
      _createElementVNode("img", {
        src: configInfo.infoImg2,
        alt: ""
      }, null, 8, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('备注')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configInfo.remark, (item) => {
        return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ]),
    (_ctx.$route.query.from !== 'rightMy' && !_unref(isOutdate) && _unref(isActive) === '0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_unref(MyButton), {
            text: _unref(submitBtnState).text,
            extraText: _unref(submitBtnState).extraText,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (handleClick(_unref(submitBtnState).status))),
            theme: "gray",
            disabled: isTeslaOwner.value
          }, null, 8, ["text", "extraText", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})